import { useSearchParams } from "react-router-dom";
import SEO from "@/components/SEO";
import { Reveal, Overline } from "@/components/Reveal";
import BookingWizard from "@/components/BookingWizard";

const Prenota = () => {
    const [searchParams] = useSearchParams();

    return (
        <div data-testid="prenota-page">
            <SEO
                title="Prenota il tuo trattamento | Studio Olistico Bologna"
                description="Prenota online il tuo massaggio olistico a Bologna: scegli trattamento, data e orario. Conferma automatica via email."
            />
            <div className="mx-auto max-w-4xl px-5 pb-28 pt-32 md:px-8 md:pt-40">
                <Reveal>
                    <Overline>Prenotazione</Overline>
                    <h1 className="mt-4 font-serif text-4xl font-light tracking-tight text-ink sm:text-5xl" data-testid="prenota-title">
                        Prenota il tuo momento
                    </h1>
                </Reveal>
                <BookingWizard initialTreatment={searchParams.get("trattamento") || ""} />
            </div>
        </div>
    );
};

export default Prenota;
